/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

import { CarouselModalProps } from './types';

const baseStyles = css`
    .button {
        &.full-screen {
            display: none;
        }
    }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
export const styles = (props: CarouselModalProps) => css`
    ${baseStyles}
`;
